import { FadeIn } from "./FadeIn";

const TEXTURE =
  "https://images.unsplash.com/photo-1741796089355-2222e20952d9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwyfHxibGFjayUyMHdoaXRlJTIwYmx1cnJlZCUyMGxhbmRzY2FwZSUyMGRhcmt8ZW58MHx8fHwxNzc4NDQ4MDMyfDA&ixlib=rb-4.1.0&q=85";

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-32 md:py-48 px-6 sm:px-10 md:px-16 border-t border-[#141414] overflow-hidden"
    >
      {/* Faint texture aside */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 opacity-[0.08]"
        style={{
          backgroundImage: `url(${TEXTURE})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: "grayscale(100%) blur(2px)",
        }}
      />
      <div className="absolute inset-0 bg-[#080808]/85" />

      <div className="relative max-w-7xl mx-auto">
        <FadeIn>
          <div className="flex items-center gap-4 mb-16 md:mb-24">
            <span className="kv-overline text-[#6b6b6b]">N° 03</span>
            <span className="h-px flex-1 bg-[#1a1a1a]" />
            <span className="kv-overline text-[#a3a3a3]">About</span>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-20">
          <FadeIn className="md:col-span-5">
            <h2 className="font-serif-display text-[#f2f0e9] text-3xl sm:text-4xl md:text-5xl leading-[1.05] italic">
              Of silence,
              <br />
              memory,
              <br />
              and reverberation.
            </h2>
          </FadeIn>

          <FadeIn className="md:col-span-6 md:col-start-7" delay={0.2}>
            <div className="space-y-6 text-[#a3a3a3] text-base sm:text-lg leading-relaxed font-light max-w-lg">
              <p>
                Kachevsky is a composer and sound artist working at the
                intersection of minimal instrumentation and spatial acoustics.
              </p>
              <p>
                The work is concerned with what remains after a sound has
                passed — with the room, the listener, and the residue of
                attention.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>
  );
};

export default About;
